export default __webpack_public_path__ + "images/0xd361474bb19c8b98870bb67f5759cdf277dee7f9.png";